import type { List } from 'immutable';
import { makeSelectLoadedSnapshots } from 'pages/SnapshotManagement/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import type { ImmutableSnapshot, Snapshot } from './snapshotManagementTypes';

interface SelectorProps {
  snapshots: List<ImmutableSnapshot>;
}

const selector = createStructuredSelector({
  snapshots: makeSelectLoadedSnapshots(),
});

export const useSnapshots = (): Snapshot[] => {
  const { snapshots } = useSelector<unknown, SelectorProps>(selector);

  return useMemo(() => {
    const plainSnapshots = snapshots
      .map((snapshot) => snapshot?.toJS())
      .filter((snapshot) => snapshot !== undefined)
      .toArray();
    return plainSnapshots as Exclude<
      (typeof plainSnapshots)[number],
      undefined
    >[];
  }, [snapshots]);
};
